import { createContext, useContext, useState } from "react";
import { usePecasContext } from "../PecasContext";
import { ProcessoContextI } from "./interfaces";

const ProcessoContext = createContext<ProcessoContextI>({} as ProcessoContextI);

export const ProcessoProvider = (props: any) => {
    const [mostrarDadosProcesso, setMostrarDadosProcesso] = useState(false);
    const [mostrarPainelIA, setMostrarPainelIA] = useState(false);
    const { processo,getProcesso,idProcesso } = usePecasContext();

    function toogleMostrarDadosProcesso() {
        setMostrarDadosProcesso(!mostrarDadosProcesso);
    }

    function toogleMostrarPainelIA() {
        setMostrarPainelIA(!mostrarPainelIA);
    }

    function updateProcesso() {
        getProcesso(idProcesso)
    }

    return (
        <ProcessoContext.Provider
            value={{
                toogleMostrarDadosProcesso,
                toogleMostrarPainelIA,
                mostrarDadosProcesso,
                mostrarPainelIA,
                processo,
                updateProcesso
            }}
        >
            {props.children}
        </ProcessoContext.Provider>
    );
};

export const useProcessoContext = () => {
    const context = useContext(ProcessoContext);

    if (!context) {
        throw new Error(
            "useProcessoContext must be used within a ProcessoProvider"
        );
    }
    return context;
};
